var Alabama = "Alabama";
var Alaska = "Alaska";
var Arizona = "Arizona";
var Arkansas = "Arkansas";
var California = "California";
var Colorado = "Colorado";
var Connecticut = "Connecticut";
var Delaware = "Delaware";
var Florida = "Florida";
var Georgia = "Georgia";
var Hawaii = "Hawaii";
var Idaho = "Idaho";
var Illinois = "Illinois";
var Indiana = "Indiana";
var Iowa = "Iowa";
var Kansas = "Kansas";
var Kentucky = "Kentucky";
var Louisiana = "Louisiana";
var Maine = "Maine";
var Maryland = "Maryland";
var Massachusetts = "Massachusetts";
var Michigan = "Michigan";
var Minnesota = "Minnesota";
var Mississippi = "Mississippi";
var Missouri = "Missouri";
var Montana = "Montana";
var Nebraska = "Nebraska";
var Nevada = "Nevada";
var Ohio = "Ohio";
var Oklahoma = "Oklahoma";
var Oregon = "Oregon";
var Pennsylvania = "Pennsylvania";
var Tennessee = "Tennessee";
var Texas = "Texas";
var Utah = "Utah";
var Vermont = "Vermont";
var Virginia = "Virginia";
var Washington = "Washington";
var Wisconsin = "Wisconsin";
var Wyoming = "Wyoming";
var USStates = {
	Alabama: Alabama,
	Alaska: Alaska,
	Arizona: Arizona,
	Arkansas: Arkansas,
	California: California,
	Colorado: Colorado,
	Connecticut: Connecticut,
	Delaware: Delaware,
	"District of Columbia (DC)": "District of Columbia (DC)",
	Florida: Florida,
	Georgia: Georgia,
	Hawaii: Hawaii,
	Idaho: Idaho,
	Illinois: Illinois,
	Indiana: Indiana,
	Iowa: Iowa,
	Kansas: Kansas,
	Kentucky: Kentucky,
	Louisiana: Louisiana,
	Maine: Maine,
	Maryland: Maryland,
	Massachusetts: Massachusetts,
	Michigan: Michigan,
	Minnesota: Minnesota,
	Mississippi: Mississippi,
	Missouri: Missouri,
	Montana: Montana,
	Nebraska: Nebraska,
	Nevada: Nevada,
	"New Hampshire": "New Hampshire",
	"New Jersey": "New Jersey",
	"New Mexico": "New Mexico",
	"New York": "New York",
	"North Carolina": "North Carolina",
	"North Dakota": "North Dakota",
	Ohio: Ohio,
	Oklahoma: Oklahoma,
	Oregon: Oregon,
	Pennsylvania: Pennsylvania,
	"Rhode Island": "Rhode Island",
	"South Carolina": "South Carolina",
	"South Dakota": "South Dakota",
	Tennessee: Tennessee,
	Texas: Texas,
	Utah: Utah,
	Vermont: Vermont,
	Virginia: Virginia,
	Washington: Washington,
	"West Virginia": "West Virginia",
	Wisconsin: Wisconsin,
	Wyoming: Wyoming
};

export { Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware, Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana, Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana, Nebraska, Nevada, Ohio, Oklahoma, Oregon, Pennsylvania, Tennessee, Texas, Utah, Vermont, Virginia, Washington, Wisconsin, Wyoming, USStates as default };
